import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';

function hasMeaningfulErrors(errors: unknown): boolean {
  if (errors === null || errors === undefined) return false;
  if (typeof errors === 'string') return errors.trim().length > 0;
  if (Array.isArray(errors)) return errors.length > 0;
  return true;
}

export const handleCommonResponseInterceptor: HttpInterceptorFn = (req, next) => {
  const shouldSetJsonContentType = () => {
    if (req.headers.has('Content-Type')) return false;
    if (req.method === 'GET' || req.method === 'HEAD') return false;
    const body = req.body;
    if (body === null || body === undefined) return false;
    if (body instanceof FormData) return false;
    if (body instanceof Blob) return false;
    if (body instanceof ArrayBuffer) return false;
    if (typeof body === 'string') return false;
    return true;
  };

  const needsJsonAccept = !req.headers.has('Accept');

  if (shouldSetJsonContentType() || needsJsonAccept) {
    req = req.clone({
      setHeaders: {
        ...(shouldSetJsonContentType() ? { 'Content-Type': 'application/json' } : {}),
        ...(needsJsonAccept ? { Accept: 'application/json' } : {}),
      },
    });
  }

  return next(req).pipe(
    map((event) => {
      if (!(event instanceof HttpResponse)) return event;

      const body = event.body;
      if (!body || typeof body !== 'object' || Array.isArray(body)) return event;

      const envelope = body as {
        success?: boolean;
        data?: unknown;
        errors?: unknown;
        statusCode?: number;
      };

      const hasEnvelopeShape =
        'success' in envelope || 'data' in envelope || 'errors' in envelope || 'statusCode' in envelope;

      if (!hasEnvelopeShape) return event;

      const success = envelope.success;
      const statusCode = envelope.statusCode ?? event.status;
      const hasErrors = hasMeaningfulErrors(envelope.errors);

      if (success === false || hasErrors || statusCode >= 400) {
        throw new HttpErrorResponse({
          error: envelope,
          status: statusCode,
          statusText: event.statusText,
          url: event.url ?? undefined,
        });
      }

      if ('data' in envelope) return event.clone({ body: envelope.data });

      return event;
    }),
  );
};
